<template>
  <v-card class="settings-modal">
    <v-card-title class="settings-modal__header">
      <slot name="heading" />
      <v-btn
        class="settings-modal__close"
        small
        icon
        :disabled="locked"
        @click.native="closeModal"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-container
      v-if="!$slots.raw"
      fluid
      grid-list-lg
    >
      <slot />
    </v-container>

    <slot name="raw" />

    <v-divider />

    <v-card-actions
      v-if="$slots.actions"
      class="settings-modal__actions"
    >
      <slot name="actions" />
    </v-card-actions>

    <v-card-text
      v-show="helperVisible"
      class="settings-modal__text-helper"
    >
      <slot name="helper" />
    </v-card-text>
  </v-card>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'SettingsModal',
    props: {
      locked: {
        type: Boolean,
        default: false
      },
      helperVisible: {
        default: false,
        type: Boolean
      }
    },
    methods: {
      ...mapActions('modal', ['closeModal'])
    }
  }
</script>

<style lang="scss">
  .settings-modal {
    &__header {
      font-size: 24px;
      font-weight: 400;
      line-height: 32px;
      padding-top: 21px;
      padding-right: 70px;
      padding-left: 29px
    }

    .container,
    &__text-helper {
      padding-right: 29px;
      padding-left: 29px;
    }

    &__close.v-btn {
      position: absolute;
      top: 11px;
      right: 0;
      color: #757575;
      margin-right: 17px;
    }

    .container {
      padding-top: 8px;
      padding-bottom: 15px;
    }

    .v-input--checkbox {
      margin-top: 0;

      .v-input__slot {
        margin-bottom: 0;
      }
    }

    .v-input--radio-group {
      margin-top: 0;

      .v-radio {
        margin-bottom: 0;
      }
    }

    &__actions {
      padding-top: 14px;
      padding-bottom: 15px;
    }

    &__text-helper {
      color: #757575;
      font-size: 13px;
      padding: 0 30px 16px;
    }
  }
</style>
